import React, { useEffect, useRef } from 'react';

// Header checkbox with the tri-state (indeterminate) that only the DOM node can carry.
const SelectAllBox = ({ checked, indeterminate, onChange, disabled }) => {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current) ref.current.indeterminate = indeterminate;
  }, [indeterminate]);
  return <input ref={ref} type='checkbox' checked={checked} onChange={onChange} disabled={disabled} />;
};

export default SelectAllBox;
